export function toDegree (y, x) {
  return Math.atan2(y, x) * (180 / Math.PI);
}


//////////////////
// WEBPACK FOOTER
// /Users/remimichel/workspace/rwigo/psip/wp-content/themes/psip/node_modules/tiny-slider/src/helpers/toDegree.js
// module id = 168
// module chunks = 0